<template lang="html">
  <div>
    <v-dialog
      v-model="NoteChatDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
      <!-- start -->
      <div v-if="status_edit === 'start'" class="pa-1">
        <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pl-2 pr-0 pt-0 pb-0"
            @click="close()"
          >
            <v-icon class="fz-30 cursor">mdi-chevron-left</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title" v-if="list_note.length !== 0">{{$t('Dialog.note.headerNote')}} ({{list_note.length}})</span>
            <span class="tab-title" v-else>{{$t('Dialog.note.headerNote')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout v-if="list_note.length !== 0" row wrap justify-start align-start class="mt-3 pl-5 pr-5 pb-5">
          <v-list
            subheader
            three-line
            class="list-overflow"
          >
            <template v-for="(item, index) in list_note">
              <v-list-item :key="item.note_id" class="cursor">
                <v-list-item-avatar class="mr-3" @click="openDialog(item, index, 'detail-note')">
                  <img v-if="item.profilepicture" :src="item.profilepicture" alt="" class="img-position">
                  <img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                </v-list-item-avatar>
                <v-list-item-content @click="openDialog(item, index, 'detail-note')">
                  <v-list-item-title class="font-list-title">{{item.nickname}}</v-list-item-title>
                  <v-list-item-subtitle v-html="item.note_data.text"></v-list-item-subtitle>
                  <v-list-item-subtitle>{{date(item.create_date)}} {{time(item.create_date)}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action @click="openDialog(item, index, 'edit')" v-if="item.owner === tokenuser">
                  <v-icon class="icon-color-edit">mdi-dots-vertical</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index < list_note.length - 1"
              ></v-divider>
            </template>
          </v-list>
        </v-layout>
        <v-layout v-else row wrap justify-center align-center class="pl-5 pr-5 pb-5 list-overflow">
          <h4>{{$t('RightSide.noNote')}}</h4>
        </v-layout>
        <v-fab-transition v-if="!ListBottomMenu">
          <v-btn class="mx-2" fab dark small fixed bottom right color="#2662ae" @click="openDialog('', '', 'create')">
            <v-icon dark>fa-solid fa-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/>
    <CreatedNoteChat :NoteChatDetail="NoteChatDetail" :CreatedNoteChatDialog="CreatedNoteChatDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
    <EditNoteChat :NoteDetail="NoteDetail" :EditNoteChatDialog="EditNoteChatDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
    <DetailNoteChat :NoteDetail="NoteDetail" :DetailNoteChatDialog="DetailNoteChatDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>

  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import ListBottomMenu from '@/components/Alert/ListBottomMenu'
import CreatedNoteChat from '@/components/CreatedNoteChat'
import EditNoteChat from '@/components/EditNoteChat'
import DetailNoteChat from '@/components/DetailNoteChat'

var _ = require('lodash')
export default {
  props: {
    NoteChatDialog: Boolean,
    NoteChatDetail: {}
  },
  data () {
    return {
      tokenuser: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      DetailNoteChatDialog: false,
      NoteDetail: {},
      EditNoteChatDialog: false,
      CreatedNoteChatDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_note: [],
      status_edit: 'start',
      progress: false,
      stylechat: {
        "--NoteChat-HeaderColor": "white",
        "--NoteChat-TabBackground": "white",
        "--NoteChat-Icon": "gray",
        "--NoteChat-IconActive": "#2662ae",
        "--NoteChat-Background": "white",
        "--NoteChat-FontSize": "18px",
        "--NoteChat-FontSize-Title": "24px",
        "--NoteChat-FontColor": "back",
        "--NoteChat-FontSize-Status": "16px",
        "--NoteChat-FontColor-Status": "grey",
        "--NoteChat-Background-Input": "#E2E1E3",
        "--NoteChat-Color-Button": "#EFF2FE",
        "--NoteChat-FontColor-Button": "#2662ae",
        "--NoteChat-FontColor-Block-Button": "#cb1002",
        "--NoteChat-FontColor-Dis-Button": "#e2e1e3",
        "--NoteChat-Btn-Confirm-Background": "#2662ae",
        "--NoteChat-Btn-Confirm-Color": "white",
        "--NoteChat-Btn-Confirm-FontSize": "18px",
        "--NoteChat-Btn-Cancel-Background": "white",
        "--NoteChat-Btn-Cancel-Color": "#2662ae",
        "--NoteChat-Btn-Cancel-FontSize": "18px",
        "--NoteChat-Btn-Leave-Background": "white",
        "--NoteChat-Btn-Leave-Color": "#ff5252",
        "--NoteChat-Btn-Leave-FontSize": "18px",
        "--NoteChat-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
    ListBottomMenu,
    CreatedNoteChat,
    EditNoteChat,
    DetailNoteChat
  },
  watch: {
    NoteChatDialog () {
      if (this.NoteChatDialog) {
        // console.log(this.NoteChatDetail)
        this.getNote()
      }
    }
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
  },
  methods: {
    emitListBottom (value) {
      // console.log(value)
      this.ListBottomMenu = false
      if (value.item.actions === 'delete-note') {
        this.openDialog(value.item, value.item.index, 'delete-note')
      } else if (value.item.actions === 'edit-note') {
        this.NoteDetail = value.item.item
        this.EditNoteChatDialog = true
      }
    },
    emitComponents (value) {
      if (value.name === 'create-note') {
        this.CreatedNoteChatDialog = false
        this.getNote()
      } else if (value.name === 'detail-note') {
        this.DetailNoteChatDialog = false
        this.getNote()
      } else if (value.name === 'edit-note') {
        this.EditNoteChatDialog = false
        this.getNote()
      }
    },
    openDialog (item, index, type) {
      // console.log(item)
      if (type === 'create') {
        this.CreatedNoteChatDialog = true
      } else if (type === 'edit') {
        this.ListBottomItem = [
          {
            text: this.$t('AnswerQuestion.edit'),
            icon: 'fa-solid fa-pen-to-square',
            actions: 'edit-note',
            id: item.note_id,
            index: index,
            item: item
          },
          {
            text: this.$t('AnswerQuestion.remove'),
            icon: 'fa-solid fa-trash-can',
            actions: 'delete-note',
            id: item.note_id,
            index: index
          }
        ]
        this.ListBottomMenu = true
      } else if (type === 'delete-note') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Dialog.note.deleteNote'),
          detail: item,
          index: index,
          type: 'delete-note'
        }
        this.WarningDialog = true
      } else if (type === 'edit-note') {
        this.NoteDetail = item
        this.EditNoteChatDialog = true
      } else if (type === 'detail-note') {
        // เอาไว้เช็คตอนกดปุ่มไอคอน list ว่าจะให้ปิดหน้ารายการโน้ตหรือให้แสดงอันใหม่ กรณีที่อยู่ในหน้าแชทหรือในหน้าโน้ต
        item.previous = 'list-note'
        this.NoteDetail = item
        this.DetailNoteChatDialog = true
      }
    },
    date (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjsdatethai(timestamp)
      } else {
        return Momenttime.dayjsdateen(timestamp)
      }
    },
    time (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjstimethai(timestamp)
      } else {
        return Momenttime.dayjstimethai(timestamp)
      }
    },
    close () {
      this.$emit('closeComponents', {
        name: 'notechat',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'delete-note') {
        this.deleteNote(item.detail.id, item.index)
      }
    },
    closeComponents (data) {
      // console.log(data)
      if (data.name === 'create-note') {
        this.CreatedNoteChatDialog = data.value
      } else if (data.name === 'edit-note') {
        this.EditNoteChatDialog = data.value
      } else if (data.name === 'detail-note') {
        this.DetailNoteChatDialog = data.value
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    deleteNote (id, index) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/removenote`, {
        note_id: id,
        tokenuser: this.NoteChatDetail.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.list_note.splice(index, 1)
          // console.log(this.list_note)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    getNote () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/getlistnote2`, {
        tokenroom: this.NoteChatDetail.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.list_note = response.data.list_note
          this.list_note = _.orderBy(this.list_note, 'create_date', 'desc')
          this.list_note = _.unionBy(this.list_note, 'note_id')
          // console.log(this.list_note)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
  }
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer;
}
.font-list-title {
  font-weight: 600;
  color: var(--NoteChat-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--NoteChat-FontSize-Title) !important;
  color: var(--NoteChat-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--NoteChat-FontSize-Title-Edit) !important;
  color: var(--NoteChat-FontColor) !important;
}
.tab-title {
  color: var(--NoteChat-FontColor) !important;
  font-size: var(--NoteChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--NoteChat-FontColor-Status) !important;
  font-size: var(--NoteChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.checkbox-color {
  color: var(--NoteChat-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--NoteChat-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--NoteChat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--NoteChat-Icon) !important;
}
.icon-color {
  color: var(--NoteChat-IconActive) !important;
}
.btn-confirm {
  background-color: var(--NoteChat-Btn-Confirm-Background) !important;
  color: var(--NoteChat-Btn-Confirm-Color) !important;
  font-size: var(--NoteChat-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--NoteChat-Btn-Cancel-Background) !important;
  color: var(--NoteChat-Btn-Cancel-Color) !important;
  font-size: var(--NoteChat-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--NoteChat-Btn-Leave-Background) !important;
  color: var(--NoteChat-Btn-Leave-Color) !important;
  font-size: var(--NoteChat-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--NoteChat-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--NoteChat-FontSize-Title) !important;
  color: var(--NoteChat-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--NoteChat-FontColor) !important;
  font-size: var(--NoteChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--NoteChat-FontColor-Status) !important;
  font-size: var(--NoteChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
